<template>
  <div>
    <div class="w-100 d-inline-block bg-book-banner-image">
      <div class="container">
        <div class="row mt-3 mb-3">
          <div class="col-12">
            <div class="w-50 d-block text-center m-auto booking-banner position-relative">
              <h1 class="text-black fw-bold fs-3 filson-black-family mt-1">
                Payment
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-book-detail-image position-relative Payment-banner-image">
      <div class="container">
        <div class="row mt-3">
          <div class="col-12 col-xl-9 mb-xl-0 mb-2 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block bg-introduction rounded-3 p-2">
              <p class="dark-black fs-5 fw-bold pt-2 inter-semi-bold">
                Checkout
              </p>
              <div class="row mt-2 row-scroll">
                <div class="col-xl-3 col-10 col-sm-6 col-md-7 col-lg-7">
                  <div class="w-100 d-inline-block dabit-card-box text-center" @click="isFirstDivVisible = true; isSecondDivVisible = false; isThirdDivVisible = false;isFourthDivVisible = false">
                    <a class="text-black text-size-14 rounded-2 d-inline-block w-100 bg-white inter-semi-bold" href="javascript:void(0)" :class="{'activebtn': activeLink === 'card'}" @click="setActiveLink('card')">
                      <img v-lazy="require('@/assets/images/debit-card-image.svg')" alt="">
                      Credit / Debit Card
                    </a>
                  </div>
                </div>
                <div class="col-xl-3 col-12 col-sm-6 col-md-7 col-lg-7">
                  <div class="w-100 d-inline-block dabit-card-box text-center" @click="isFirstDivVisible = false; isSecondDivVisible = true; isThirdDivVisible = false;isFourthDivVisible = false">
                    <a class="text-black text-size-14 rounded-2 d-inline-block w-100 bg-white inter-semi-bold" href="javascript:void(0)" :class="{'activebtn': activeLink === 'pay'}" @click="setActiveLink('pay')">
                       <img v-lazy="require('@/assets/images/google-play-image-icon.svg')" alt="">
                      Google Pay
                    </a>
                  </div>
                </div>
                <div class="col-xl-3 col-12 col-sm-6 col-md-7 col-lg-7">
                  <div class="w-100 d-inline-block dabit-card-box text-center" @click="isFirstDivVisible = false; isSecondDivVisible = false; isThirdDivVisible = true;isFourthDivVisible = false">
                    <a class="text-black text-size-14 rounded-2 d-inline-block w-100 bg-white inter-semi-bold" href="javascript:void(0)" :class="{'activebtn': activeLink === 'cash'}" @click="setActiveLink('cash')">
                      <img v-lazy="require('@/assets/images/cash-image-icon.svg')" alt="">
                      Cash (+5 AED)
                    </a>
                  </div>
                </div>
                <div class="col-xl-3 col-12 col-sm-6 col-md-7 col-lg-7">
                  <div class="w-100 d-inline-block dabit-card-box text-center" @click="isFirstDivVisible = false; isSecondDivVisible = false; isThirdDivVisible = false;isFourthDivVisible = true">
                    <a class="text-black text-size-14 rounded-2 d-inline-block w-100 bg-white inter-semi-bold" href="javascript:void(0)" :class="{'activebtn': activeLink === 'apple'}" @click="setActiveLink('apple')">
                      <img v-lazy="require('@/assets/images/apply-image-icon.svg')" alt="">
                      Apple Pay
                    </a>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="w-100 d-inline-block" v-if="isFirstDivVisible">
                    <div class="row mt-3">
                      <div class="col-xl-6 col-12 mb-xl-0 mb-0">
                        <div class="w-100 d-inline-block bg-white p-2 rounded-2">
                          <form>
                            <label class="w-100 d-inline-block fw-bold text-black mb-2 text-size-14 medium-family">Card Holder Name </label>
                            <input class="w-100 bg-introduction text-size-14 h-40 ps-3 pe-3 border rounded-2" type="text" placeholder="Full Name" />
                          </form>
                        </div>
                      </div>
                      <div class="col-xl-6 col-12 mb-xl-0 mb-0">
                        <div class="w-100 d-inline-block bg-white p-2 rounded-2">
                          <form>
                            <label class="w-100 d-inline-block fw-bold text-black mb-2 text-size-14 medium-family">Card Number
                            </label>
                            <input class="w-100 bg-introduction text-size-14 h-40 ps-3 pe-3 border rounded-2" type="number" placeholder="xxxx-xxxx-xxxx-xxxx" />
                          </form>
                        </div>
                      </div>
                      <div class="col-xl-6 col-12 mb-xl-0 mb-0">
                        <div class="w-100 d-inline-block bg-white p-2 rounded-2 mt-2">
                          <form>
                            <label class="w-100 d-inline-block fw-bold text-black mb-2 text-size-14 medium-family">
                              Exp. Date
                            </label>
                            <div class="w-100 d-inline-block customer-form date-select-picker position-relative" onclick="document.querySelector('.date').showPicker()">
                    <input class="w-100 bg-introduction text-size-14 h-40 ps-3 pe-3 border rounded-2 custom-date date" type="date" id="exampleInputDate" aria-describedby="emailHelp" placeholder="Select Date" />
                    <img class="custom-calendar-icon" v-lazy="require('@/assets/images/calendar-image-icon.svg')" alt="">
                  </div>
                          </form>
                        </div>
                      </div>
                      <div class="col-xl-6 col-12 mb-xl-0 mb-0">
                        <div class="w-100 d-inline-block bg-white p-2 rounded-2 mt-2">
                          <form>
                            <label class="w-100 d-inline-block fw-bold text-black mb-2 text-size-14 medium-family">
                              CVV Number
                            </label>
                            <input class="w-100 bg-introduction text-size-14 h-40 ps-3 pe-3 border rounded-2" type="number" placeholder="1234" />
                          </form>
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <div class="w-100 d-inline-block text-center">
                          <a class="w-100 d-inline-block bg-blue rounded-5 text-white fw-bold text-size-14 p-2 inter-semi-bold" href="javascript:void(0)">
                            Confirm and Pay
                          </a>
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <ul class="w-100 d-inline-block Checkout-menu mb-0 ps-3">
                          <li>
                            <span class="strike-text text-size-14 inter-regular-family">
                              AED 3.67 will be charged to verify your card. The amount will be refunded immediately.
                            </span>
                          </li>
                          <li>
                            <span class="strike-text text-size-14 inter-regular-family">
                              The session amount will be reserved on your card. You will only be charged once the session is completed.
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div class="col-12 mt-2">
                        <div class="w-55 d-inline-block bg-white p-2 rounded-2 w-xs-100 w-sm-100 w-md-100 w-ipad-100 input-discount">
                          <form>
                            <label class="w-100 d-inline-block fw-bold text-black mb-2 text-size-14 medium-family">
                              Discount Voucher Code
                            </label>
                            <input class="w-80 bg-introduction text-size-14 h-40 ps-3 pe-3 border float-start" type="text" placeholder="Discount Voucher Code" />
                            <button type="button" class="text-size-14 text-white fw-bold h-40 float-start bg-text bg-green ps-xl-3 ps-1 pe-xl-3 pe-1 medium-family border-0">
                              Apply
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-100 d-inline-block" v-if="isSecondDivVisible">
                    hh
                  </div>
                  <div class="w-100 d-inline-block" v-if="isThirdDivVisible">
                    bb
                  </div>
                  <div class="w-100 d-inline-block" v-if="isFourthDivVisible">
                    tt
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-3 mb-xl-0 mb-2 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block bg-introduction rounded-3 p-2 pb-3">
              <p class="text-black text-size-16 mb-0 inter-semi-bold">Booking Details</p>
              <div class="w-100 d-inline-block bg-white rounded-top mt-2">
                <div class="w-100 d-inline-block border-bottom p-2">
                  <div class="row">
                    <div class="col-xl-4 col-5 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family">
                          Service
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-8 col-7 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-black medium-family">
                          Dog, Cat Grooming
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-inline-block border-bottom p-2">
                  <div class="row">
                    <div class="col-xl-6 col-8 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family">
                          Service Details
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-6 col-4 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <a href="javascript:void(0)" class="text-size-14 edit-text inter-bold-family">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-8 col-8 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 text-black medium-family">
                          Small Dog
                          <span class="text-green">x1</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-4 col-4 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family"> AED 119 </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-inline-block border-bottom p-2">
                  <div class="row">
                    <div class="col-xl-8 col-8 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 text-black medium-family">
                          Car
                          <span class="bg-text">x1 </span>
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-4 col-4 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family">AED 119 </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-inline-block p-2">
                  <div class="row">
                    <div class="col-xl-8 col-8 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 text-black medium-family">
                          Full Medium Dog
                          <span class="text-green medium-family">x1</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-4 col-4 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family">AED 119 </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-inline-block rounded-3 bg-gallery mt-2">
                <div class="w-100 d-inline-block border-bottom p-2">
                  <p class="text-size-14 text-black mb-0 medium-family">
                    Payment Summary
                  </p>
                </div>
                <div class="w-100 d-inline-block p-2">
                  <div class="row">
                    <div class="col-xl-6 col-7 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family">Total </span>
                      </div>
                    </div>
                    <div class="col-xl-6 col-5 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family">
                          AED 476
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-inline-block bg-white rounded-3 mt-2">
                <div class="w-100 d-inline-block border-bottom p-2">
                  <p class="text-size-14 strike-text mb-0 medium-family">
                    Address
                  </p>
                </div>
                <div class="w-100 d-inline-block p-2">
                  <p class="text-size-13 dark-black mb-0 family-inter-light">
                     {{ address }}
                  </p>
                </div>
              </div>
              <div class="w-100 d-inline-block mt-2 text-center">
                <a class="bg-green rounded-5 text-white d-inline-block p-1 w-100 inter-semi-bold text-size-14" href="javascript:void(0)">
                  Next
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
    bg-introduction mt-3">
      <div class="container">
        <div class="row mt-2 mb-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0">
        <li class="float-start me-2">
          <a class="text-black text-size-14 medium-family" href="javascript:void(0)">
            <i class="fa fa-home nav-color" aria-hidden="true"></i>
            Home  /
          </a>
        </li>
        <li class="float-start">
          <a class="text-black text-size-14 medium-family" href="javascript:void(0)">
            Services
          </a>
        </li>
      </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "paymentBannerComponent",
    data() {
    return {
      isFirstDivVisible: true,
      isSecondDivVisible: false,
      isThirdDivVisible: false,
      isFourthDivVisible: false,
      activeLink: 'card',
      selectedLanguage: "",
    };
  },
  methods: {
    setActiveLink(link) {
      this.activeLink = link;
    },
  },
  };
</script>

<style scoped></style>
